import type { VoidFunctionComponent } from 'react';

import ProjectSummaryV2IssueScanDropdown from './ProjectSummaryV2IssueScanDropdown';

import styles from './ProjectSummaryV2Heading.module.less';

type Props = {
  projectTypeTitle: string;
  revisionLocator?: string;
};

export const ProjectSummaryV2Heading: VoidFunctionComponent<Props> = ({ projectTypeTitle, revisionLocator }) => {
  return (
    <div className={styles.heading}>
      <div>
        <div className={styles.summaryText}>Summary</div>
        <div className={styles.projectTypeTitle}>{projectTypeTitle}</div>
      </div>
      <div>
        {revisionLocator && <ProjectSummaryV2IssueScanDropdown revisionLocator={revisionLocator} />}
      </div>
    </div>
  );
};
